/**
 * BuilderSiteNow brand artwork — vector path data.
 *
 * Source of truth for the folded-"B" symbol used across the app. Kept as raw
 * path strings (not a component) so it can be rendered both by React DOM
 * (BrandMark.tsx) and by the next/og Satori runtime (icon / apple-icon /
 * opengraph-image routes), which can't import a client component.
 *
 * Extracted from the design deliverable "BSN Symbol color option 06.svg".
 * The mark's intrinsic art colour is terracotta; recolour via the `fill`
 * passed by the consumer (white on the icon tiles, terracotta on light UI).
 */

/** Brand mark fill — kept in sync with the committed theme primary so the logo
 *  matches the rest of the product. Currently Slate & Emerald (#047857).
 *  (Const name retained for backwards-compat with existing imports.) */
export const BRAND_TERRACOTTA = '#047857';

/** Symbol viewBox — taller than wide (≈0.72 aspect ratio). */
export const SYMBOL_VIEWBOX = '0 0 117 162';
export const SYMBOL_ASPECT = 117 / 162;

/** The two folded panels that compose the "B" mark. */
export const SYMBOL_PATHS: readonly string[] = [
  'M54.995 43.996L8.45943 6.76754C5.05022 4.04018 0 6.46744 0 10.8334V124.874C0 126.734 0.992405 128.453 2.60339 129.383L49.139 156.25C52.6102 158.254 56.9492 155.749 56.9492 151.741V48.0618C56.9492 46.4801 56.2301 44.9841 54.995 43.996Z',
  'M113.552 90.2698L67.0166 63.678C63.5455 61.6945 59.2266 64.2009 59.2266 68.1988V153.011C59.2266 156.791 63.1288 159.312 66.5748 157.757L113.11 136.759C114.976 135.917 116.176 134.06 116.176 132.013V94.7905C116.176 92.9221 115.175 91.1968 113.552 90.2698Z',
];
